
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/changePwd",
      function () {
        return require("private-next-pages/user/changePwd.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/changePwd"])
      });
    }
  